import {AgGridReact} from "ag-grid-react";

class BaseGrid extends AgGridReact {
}

export default BaseGrid;
